import { useCallback, useEffect, useMemo, useState } from 'react';

import { ButtonLink } from '@pinvest/sirius-button';
import ButtonOutlinePrimary from '@pinvest/sirius-button/dist/button_outline_primary';
import Divider from '@pinvest/sirius-divider/dist/divider';
import OtpInput from '@pinvest/sirius-input/dist/otp-input';
import clsx from 'clsx';
import Link from 'next/link';

import Text from '@/components/shared/Text';
import { waPinfinance2 } from '@/constants/externalUrls';
import { verificationTypeMapper } from '@/constants/verification';
import { useParsedUserAgent } from '@/contexts/parsedUserAgent';

import styles from './styles.module.css';
import type { OTPFormProps } from './types';


const OTPForm = ({ phoneNumber, verificationMethod, tooglePreviousForm, resendOtp, verifyOtp, errorVerifyOtp }: OTPFormProps) => {
  const { isMobile } = useParsedUserAgent();

  const [resendOtpTime, setResendOtpTime] = useState(30);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (resendOtpTime > 0) {
        setResendOtpTime(resendOtpTime - 1);
      }
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [resendOtpTime]);

  const verificationMethodLabel = useMemo(() => {
    return verificationTypeMapper(verificationMethod)?.label;
  }, [verificationMethod]);

  const isResendEnabled = useMemo(() => {
    if (resendOtpTime > 0) {
      return false;
    }
    return true;
  }, [resendOtpTime]);

  const handleOTPInputSubmit = useCallback((value: string) => {
    verifyOtp(value);
  }, [verifyOtp]);

  const handleResendOtpClicked = useCallback(() => {
    setResendOtpTime(30);
    resendOtp();
  }, [resendOtp]);

  return (
    <div className={styles['otp-form']} data-testid='frm-otp'>
      <div>
        {!isMobile &&
          <>
            <Text typography='label1'>
              Masukkan Kode Verifikasi
            </Text>
            <br />
          </>
        }
        <Text typography='body2'>
          Masukkan kode verifikasi yang Anda terima melalui {verificationMethodLabel} di <b>{phoneNumber}</b>
        </Text>
      </div>
      <div className={styles['otp-form__input-section']}>
        <OtpInput hasError={!!errorVerifyOtp} onSubmit={handleOTPInputSubmit} />
      </div>
      <div className={clsx(styles['otp-form__section_center'], styles['otp-form__section'])} data-testid='text-otp-errorMessage'>
        <Text typography='body2' color='negative' >{errorVerifyOtp}</Text>
      </div>
      <div className={clsx(styles['otp-form__section_center'], styles['otp-form__section_margin-bottom'])}>
        <Text typography='body2'>
          Belum menerima kode verifikasi? Tunggu <b>{resendOtpTime} detik</b>
        </Text>
      </div>
      <div>
        <div className={clsx(styles['otp-form__section_center'], styles['otp-form__cta-section'])}>
          <ButtonOutlinePrimary testId='btn-resend-otp' fullWidth size='large' disabled={!isResendEnabled} onClick={handleResendOtpClicked} >
            Kirim Ulang Kode Verifikasi
          </ButtonOutlinePrimary>
        </div>
        {tooglePreviousForm &&
          <div className={clsx(styles['otp-form__section_center'], styles['otp-form__cta-section'])}>
            <ButtonLink testId='btn-otpForm-changePhoneNumber' onClick={tooglePreviousForm} fullWidth size='large' >
              Ubah Nomor Handphone
            </ButtonLink>
          </div>
        }
      </div>
      <Divider variant='line' gutter={16} />
      <div className={styles['otp-form__section_center']}>
        <Text typography='body2' color='subtle'>
          Butuh Bantuan atau Solusi ? Silakan {' '}
          <Link href={waPinfinance2}>
            <a>
              <Text color='primary' typography='body2'>Hubungi Kami</Text>
            </a>
          </Link>
        </Text>
      </div>
    </div >
  );
};

export default OTPForm;